import { getObjectKeysAsObject } from "@checkout/helpers";
import {
  CardPaymentServices,
  CartFulfillServices,
  CartQuoteServices,
  CartUpdateServices,
  FlightServices,
  ReviewServices,
} from "@checkout/states";

export const Services = {
  ...CardPaymentServices,
  ...CartFulfillServices,
  ...CartQuoteServices,
  ...CartUpdateServices,
  ...FlightServices,
  ...ReviewServices,
};

export const ServiceTypes = getObjectKeysAsObject(Services);
